/* eslint-disable no-underscore-dangle */
import ldRedux from 'ld-redux';
import { isEmpty } from 'lodash';
import useDeepCompareEffect from 'hooks/useDeepCompareEffect';
import { useDispatch, useSelector } from 'react-redux';
import { getFeatureUserSettings } from 'actions';
import {
  getFeatureFlags, getFeatureUserSettings as getFeatureUserSettingsSelector
} from 'selectors';
import env from '@beam-australia/react-env';

const clientSideId = env('LAUNCH_DARKLY_CLIENT_SIDE_ID');

// ld-redux states
// ------------------------- + ------------------------------------
//          Event            |             Redux State
// ------------------------- + ------------------------------------
// before ldRedux.init       | features = {}
// right after ldRedux.init  | features = { isLDReady: false }
// after flags load          | features = { isLDReady: true, ... }
// ------------------------- + ------------------------------------

export const useFeatureFlaggingService = () => {
  const dispatch = useDispatch();

  const { isLDReady } = useSelector(getFeatureFlags);
  const featureUserSettings = useSelector(getFeatureUserSettingsSelector);
  const didSettingsLoad = isEmpty(featureUserSettings) === false;
  useDeepCompareEffect(() => {
    if (didSettingsLoad === false) {
      dispatch(getFeatureUserSettings());
    }
    // initialize launchDarkly
    if (didSettingsLoad) {
      const { custom, ...rest } = featureUserSettings;
      ldRedux.init({
        clientSideId,
        dispatch,
        context: { kind: 'user', ...custom, ...rest }
      });
    }
  }, [featureUserSettings]);

  return isLDReady === true;
};

export default useFeatureFlaggingService;
